module.exports = __webpack_public_path__ + "static/img/zcbg.a341823.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zcbg.png
// module id = pOgr
// module chunks = 0